import { render, staticRenderFns } from "./TwAddPermit.vue?vue&type=template&id=1e0e2fa4&"
import script from "./TwAddPermit.vue?vue&type=script&lang=js&"
export * from "./TwAddPermit.vue?vue&type=script&lang=js&"
import style0 from "./TwAddPermit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports